import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const API_URL = import.meta.env.VITE_API_URL;

const ContactIdService = {
    save: async (data) => axios.post(`${API_KEEPER}/contactid/place`, data).then((data) => data).catch((err) => { throw err }),

    update: async (id, data) => axios.put(`${API_KEEPER}/contactid/place/${id}`, data).then((data) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(`${API_KEEPER}/contactid/place/${id}`).then((data) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_KEEPER + `/contactid/get/${id}`).then(({ data }) => data).catch((err) => { throw err }),

    openDvr: async (id) => axios.post(`${API_KEEPER}/contactid/place/${id}/opendvr`).then((data) => data).catch((err) => { throw err }),

    armingDisarming: (func, partition, account, mainAccount) => axios.post(`${API_KEEPER}/contactid/place/armingdisarming`, { function: func, partition, account, mainAccount }),

    alarmStatus: async (mainAccount) => axios.post(`${API_KEEPER}/contactid/place/alarmstatus/${mainAccount}`).then((data) => data).catch((err) => { throw err }),

    alarmTest: async (data) => axios.post(`${API_KEEPER}/contactid/place/alarm/test`, data).then((data) => data).catch((err) => { throw err }),

    keyGenerator: async (data) => axios.get(`${API_KEEPER}/firealarm/keygenerator`, data).then((data) => data).catch((err) => { throw err }),

    getEventTypes: async () => axios.get(`${API_URL}/contactEvent/get/eventTypes`).then((data) => data).catch((err) => {throw err;}),

    getFireAlarmEventTypes: async () => axios.get(`${API_URL}/contactEvent/get/fireAlarmEventTypes`).then((data) => data).catch((err) => {throw err;}),

    filterEvents: async (payload) => axios.post(`${API_URL}/contactEvent/filter`, payload).then((data) => data).catch((err) => {throw err;}),

    getAllEventTypes: async () => axios.get(`${API_URL}/contactid-event-types/get/all-event-types`).then((data) => data).catch((err) => {throw err;}),

    saveEventType: async (payload) => axios.post(`${API_KEEPER}/contactid/reportcodes/update`, payload).then((data) => data).catch((err) => {throw err;}),

    lastEvent: async () => axios.get(`${API_URL}/contactEvent/get/eventTypes/false`).then(({data}) => data).catch((err) => {throw err;}),

    apply: async (payload) => axios.post(`${API_URL}/reports/contactid`, payload).then(({data}) => data.data).catch((err) => {throw err;}),

    updateEventObservation: async (id, observation) => axios.patch(`${API_URL}/contactEvent/event/${id}/observation`, { observation }).then((data) => data).catch((err) => { throw err }),
}

export default ContactIdService;